import { LocaleResources } from 'locales';
import React from 'react';
import { Product } from 'src/models/product/schema';
import styles from '../index.module.scss';
import clsx from 'clsx';

type Props = {
  isProductList: boolean;
  product: Product;
  localeResources: LocaleResources;
  productSaleHref: string;
  openZendesk: () => void;
};

export const Description: React.FC<Props> = ({
  isProductList,
  product,
  localeResources,
  productSaleHref,
  openZendesk,
}) => {
  return (
    <div className={styles.wrap}>
      {isProductList && (
        <>
          {product?.description && (
            <>
              <div className={clsx(styles.bold, styles.mt10)}>■{localeResources.products.desc}</div>
              <div className={styles.mt10}>{product?.description}</div>
            </>
          )}
          {product?.medicalProhibitions && (
            <>
              <div className={clsx(styles.bold, styles.mt10)}>
                ■{localeResources.products.medicine.contraindications}
              </div>
              <div className={styles.mt10}>{product?.medicalProhibitions}</div>
            </>
          )}
          {product?.medicalNeedConsultation && (
            <>
              <div className={clsx(styles.bold, styles.mt10)}>■{localeResources.products.medicine.consult}</div>
              <div className={styles.mt10}>{product?.medicalNeedConsultation}</div>
            </>
          )}
          {product?.medicalEffects && (
            <>
              <div className={clsx(styles.bold, styles.mt10)}>■{localeResources.products.medicine.effects}</div>
              <div className={styles.mt10}>{product?.medicalEffects}</div>
            </>
          )}
          {product?.medicalUsage && (
            <>
              <div className={clsx(styles.bold, styles.mt10)}>■{localeResources.products.medicine.administration}</div>
              <div className={styles.mt10}>{product?.medicalUsage}</div>
            </>
          )}
          {product?.ingredient && (
            <>
              <div className={clsx(styles.bold, styles.mt10)}>■{localeResources.products.medicine.Ingredients}</div>
              <div className={styles.mt10}>{product?.ingredient}</div>
            </>
          )}
          {product?.medicalHowToStore && (
            <>
              <div className={clsx(styles.bold, styles.mt10)}>■{localeResources.products.medicine.precautions}</div>
              <div className={styles.mt10}>{product?.medicalHowToStore}</div>
            </>
          )}
        </>
      )}

      {product?.medicalContactInfo && (
        <>
          <div className={clsx(styles.bold, styles.mt10)}>■{localeResources.products.medicine.distributorContact}</div>
          <ul className={styles.mt10}>
            {product?.medicalContactInfo.split('\n').map((contactInfo, index) => <li key={index}>{contactInfo}</li>)}
          </ul>
        </>
      )}
      <div className={clsx(styles.bold, styles.mt10)}>■{localeResources.products.medicine.Inquiries}</div>
      <div className={clsx(styles.mt10, styles.link)} onClick={() => openZendesk()}>
        {localeResources.products.medicine.InquiriesForClick}
      </div>
      <div className={clsx(styles.bold, styles.mt10)}>■{localeResources.guide.notes.other}</div>
      <div className={clsx(styles.mt10, styles.link)}>
        <a href={productSaleHref} target="_blank" rel="noopener noreferrer">
          {localeResources.products.medicine.Information.title}
        </a>
      </div>
    </div>
  );
};
